module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "showcase-circle"
  }, [(_vm.images.length > 0) ? _c('swiper', {
    attrs: {
      "slides": _vm.images
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "product-name"
  }, [_vm._v(_vm._s(_vm.productData.ProductName))]), _vm._v(" "), _c('div', {
    staticClass: "sub-product-name"
  }, [_vm._v(_vm._s(_vm.productData.SubProductName))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-2b2830b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2b2830b6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/pack/swiper-card.vue
// module id = 1063
// module chunks = 1